import React from 'react'

import './BlueGrayBox.scss'

export const BlueGrayBox = ({ className, onClick, ...props }) => {
  return (
    <div onClick={!!onClick && onClick} className={`bluebox lightgrayblue ${className}`} {...props}>
      {props.children}
    </div>
  )
}
